import { render } from "./HomeBoardList.vue?vue&type=template&id=33dcaf35&scoped=true&ts=true"
import script from "./HomeBoardList.vue?vue&type=script&lang=ts"
export * from "./HomeBoardList.vue?vue&type=script&lang=ts"

import "./HomeBoardList.vue?vue&type=style&index=0&id=33dcaf35&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33dcaf35"]])

export default __exports__